import * as Sentry from "@sentry/react";
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Alert, CompatibilityWarning, ConnectRoom, ErrorFallback, Settings } from '@/components';
import CallEnded from '@/pages/CallEnded';
import Diagnostics from '@/pages/Diagnostics';
import Lobby from '@/pages/Lobby';
import Room from '@/pages/Room';
import Welcome from '@/pages/Welcome';
import { AppSetup } from './components';
import { store } from './store';

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <CompatibilityWarning>
        <Provider store={store}>
          <AppSetup>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Welcome />} />
                <Route path="/home/:id" element={<Lobby />} />
                <Route path="/room/:id" element={<ConnectRoom><Room /></ConnectRoom>} />
                <Route path="/end/:id" element={<CallEnded />} />
                <Route path="/diagnostics" element={<Diagnostics />} />
                <Route path="*" element={<Welcome />} />
              </Routes>
              <Alert />
              <Settings />
            </BrowserRouter>
            <ToastContainer
              position="top-right"
              autoClose={4000}
              closeButton={false}
              hideProgressBar
              newestOnTop
              closeOnClick
            />
          </AppSetup>
        </Provider>
      </CompatibilityWarning>
    </Sentry.ErrorBoundary>
  );
}

export default App;
